import React, { useState } from "react";
import { FormControl, TextField } from "@material-ui/core";
import { useStore } from "@store/store";

import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enAU } from "date-fns/locale";
import calendarIcon from "@assets/images/calendar-icon.svg";
import moment from "moment";
import { PopupStyle } from "./style";
import {
  utcToLocal
} from "@utils/commonFunctions";

function FuelSurchargePopup(props) {
  const classes = PopupStyle();
  const [state, dispatch] = useStore();
  const currentDate = utcToLocal(null, state?.customer?.customerByIdData?.cities?.timezone, "YYYY-MM-DD");
  const [endDateError, setEndDateError] = useState(false);
  const [endDateHelperText, setEndDateHelperText] = useState("");

  const handleChange = (val) => {
    if (!val || !moment(val, "YYYY-MM-DD", true).isValid()) {
      setEndDateError(true);
      setEndDateHelperText("Please enter a valid date");
      return;
    }

    const startDate = moment(props.getDataFuel?.startDate, "YYYY-MM-DD");
    const endDate = moment(val, "YYYY-MM-DD");

    if (endDate.isBefore(startDate)) {
      setEndDateError(true);
      setEndDateHelperText("End date cannot be earlier than start date");
      return;
    }

    setEndDateError(false);
    setEndDateHelperText("");

    props.setDataFuel((prev) => ({
      ...prev,
      endDate: val,
    }));
  };

  return (
    <>
      <div className="form-row">
        <div className="form-group">
          <FormControl variant="outlined">
            <label className="label-text" htmlFor="number">
              Customer
            </label>
            <TextField
              id="number"
              variant="outlined"
              className={classes.customBackgroundInput}
              type="text"
              disabled={true}
              value={props?.getDataFuel?.customers?.name}
            />
          </FormControl>
        </div>
        <div className="form-group">
          <FormControl variant="outlined">
            <label className="label-text" htmlFor="flight">
              City
            </label>
            <TextField
              id="flight"
              disabled={true}
              variant="outlined"
              className={classes.customBackgroundInput}
              type="text"
              value={props?.getDataFuel?.cities?.name}
            />
          </FormControl>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <FormControl variant="outlined">
            <label className="label-text">Start date</label>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enAU}>
              <KeyboardDatePicker
                variant="inline"
                format="dd/MM/yyyy"
                className={classes.customBackgroundInput}
                name="to"
                disabled={true}
                value={props?.getDataFuel?.startDate}
                maxDate={new Date()}
                error={null}
                helperText={null}
                autoOk
                onChange={() => {}}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </div>
        <div className="form-group">
          <FormControl variant="outlined">
            <label className="label-text">End date</label>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enAU}>
              <KeyboardDatePicker
                variant="inline"
                format="dd/MM/yyyy"
                className="custom-datepicker"
                keyboardIcon={<img src={calendarIcon} alt="calendar" />}
                value={props.getDataFuel?.endDate || (props.getDataFuel?.status === "Scheduled" ? props.getDataFuel?.startDate : currentDate) }
                onChange={handleChange}
                minDate={ props.getDataFuel?.status === "Scheduled" ? props.getDataFuel?.startDate : currentDate }
                disableFuture={false}
                autoOk
                error={endDateError}
                helperText={endDateError ? endDateHelperText : null}
                TextFieldComponent={(props) => (
                <TextField
                  {...props}
                  InputProps={{
                    ...props.InputProps,
                    readOnly: true,
                  }}
                />
              )}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <FormControl variant="outlined">
            <label className="label-text" htmlFor="Quantity">
              Fuel Surcharge: {props?.getDataFuel?.fuelSurcharge}%
            </label>
          </FormControl>
        </div>
      </div>
    </>
  );
}

export default FuelSurchargePopup;
